import * as React from "react";
import { graphql } from "react-apollo";
import gql from "graphql-tag";

import BOGraphQLLoader from "app/components/BOComponents/BOGraphQLLoader";
import withPagination, { PaginationProps } from "app/utils/withPagination";
import ConfigurableTable from "app/components/AppComponents/ConfigurableTable";
import walletP2pColumns from "./walletP2pColumns";

type Props = {
  name: string;
  filterDate: {
    from: Date;
    to: Date;
  };
};

const query = gql`
  query walletP2p(
    $offset: Int
    $limit: Int
    $created_at_from: String
    $created_at_to: String
  ) {
    wallet_loads(
      load_type: "p2p_receive"
      offset: $offset
      limit: $limit
      created_at_from: $created_at_from
      created_at_to: $created_at_to
      levenshtein_min: 0.85
    ) {
      created_at
      wallet_name
      load_type
      amount
      payment {
        payment_strategy
        reference
        user_reference
        snapmin_url
        status
      }
      friend_connection {
        from {
          email
          snapmin_url
          external_reference
        }
        to {
          email
          snapmin_url
          external_reference
        }
      }
    }
  }
`;

const withData = graphql<any, Props & PaginationProps>(query, {
  options: ({ filterDate: { from, to }, pagination: { offset, limit } }) => ({
    fetchPolicy: "network-only",
    variables: {
      offset,
      limit,
      created_at_from: from,
      created_at_to: to,
    },
  }),
});

export default withPagination(
  withData((props) => {
    return (
      <BOGraphQLLoader data={props.data}>
        <ConfigurableTable
          columnConfigs={walletP2pColumns}
          defaultColumns={[
            "Date",
            "Wallet",
            "Payment",
            "From",
            "To",
            "Amount",
            "Reason",
          ]}
          rows={props.data.wallet_loads || []}
          pagination={props.pagination}
          name={props.name}
        />
      </BOGraphQLLoader>
    );
  })
);
